import * as React from "react";

import { JSX } from "react/jsx-runtime";

const VerifiedIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
    <svg
    width={30}
    height={31}
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="checkmark-badge-02">
      <g id="Vector">
        <path
          d="M23.7381 24.25H23.75H23.7381ZM23.7381 24.25C22.9597 25.0219 21.5491 24.8296 20.5599 24.8296C19.3456 24.8296 18.7609 25.0671 17.8942 25.9338C17.1564 26.6718 16.1671 28 15 28C13.8329 28 12.8436 26.6718 12.1057 25.9338C11.2391 25.0671 10.6544 24.8296 9.44007 24.8296C8.45085 24.8296 7.04023 25.0219 6.26186 24.25C5.47726 23.472 5.67035 22.0555 5.67035 21.0599C5.67035 19.8018 5.3952 19.2232 4.49923 18.3272C3.16643 16.9945 2.50002 16.328 2.5 15.5C2.50001 14.6719 3.1664 14.0055 4.49919 12.6727C5.299 11.8729 5.67035 11.0803 5.67035 9.94007C5.67035 8.95081 5.47811 7.54017 6.25 6.7618C7.02804 5.97723 8.4445 6.17033 9.4401 6.17033C10.5803 6.17033 11.3729 5.799 12.1727 4.99921C13.5055 3.6664 14.1719 3 15 3C15.8281 3 16.4945 3.6664 17.8272 4.99921C18.6269 5.79884 19.4194 6.17033 20.5599 6.17033C21.5491 6.17033 22.9599 5.97809 23.7383 6.75C24.5228 7.52804 24.3296 8.94449 24.3296 9.94007C24.3296 11.1982 24.6049 11.7767 25.5008 12.6727C26.8336 14.0055 27.5 14.6719 27.5 15.5C27.5 16.328 26.8336 16.9945 25.5008 18.3272C24.6047 19.2232 24.3296 19.8018 24.3296 21.0599C24.3296 22.0555 24.5227 23.472 23.7381 24.25Z"
          fill="#34A853"
        />
        <path
          d="M23.7381 24.25H23.75M23.7381 24.25C22.9597 25.0219 21.5491 24.8296 20.5599 24.8296C19.3456 24.8296 18.7609 25.0671 17.8943 25.9338C17.1564 26.6718 16.1671 28 15 28C13.8329 28 12.8436 26.6718 12.1057 25.9338C11.2391 25.0671 10.6544 24.8296 9.44008 24.8296C8.45085 24.8296 7.04023 25.0219 6.26186 24.25C5.47726 23.472 5.67035 22.0555 5.67035 21.0599C5.67035 19.8018 5.3952 19.2232 4.49923 18.3272C3.16643 16.9945 2.50002 16.328 2.5 15.5C2.50001 14.6719 3.1664 14.0055 4.49919 12.6727C5.299 11.8729 5.67035 11.0804 5.67035 9.94008C5.67035 8.95081 5.47811 7.54017 6.25 6.7618C7.02804 5.97722 8.4445 6.17033 9.4401 6.17033C10.5803 6.17033 11.3729 5.799 12.1727 4.99921C13.5055 3.6664 14.1719 3 15 3C15.8281 3 16.4945 3.6664 17.8272 4.99921C18.6269 5.79884 19.4194 6.17033 20.5599 6.17033C21.5491 6.17033 22.9599 5.97809 23.7383 6.75C24.5228 7.52804 24.3296 8.94449 24.3296 9.94008C24.3296 11.1982 24.6049 11.7767 25.5008 12.6727C26.8336 14.0055 27.5 14.6719 27.5 15.5C27.5 16.328 26.8336 16.9945 25.5008 18.3272C24.6048 19.2232 24.3296 19.8018 24.3296 21.0599C24.3296 22.0555 24.5227 23.472 23.7381 24.25Z"
          stroke="#34A853"
          strokeWidth={1.5}
        />
      </g>
      <path
        id="Vector_2"
        d="M11.25 16.6161L13.5 18.625L18.75 12.375"
        stroke="#FBFBFB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default VerifiedIcon;
